import Image from "components/Image"
import getSbImageDimensions from "utilities/getSbImageDimensions"

export default function InlineImage({ blok }) {
  return (
    <figure className="w-full py-4">
      <Image
        src={blok.image.filename}
        alt={blok.image.alt}
        placeholder={blok.image?.blurDataURL ? "blur" : "empty"}
        blurDataURL={blok.image?.blurDataURL}
        height={getSbImageDimensions("height", blok.image.filename)}
        width={getSbImageDimensions("width", blok.image.filename)}
      />
      {blok?.caption ? <figcaption className="font-bold mt-3">{blok?.caption}</figcaption> : null}
    </figure>
  )
}
